import { createFileRoute } from '@tanstack/react-router'
import { AwaitingApproval } from '@/features/doctor-signup/components/awaiting-approval'

export const Route = createFileRoute('/(auth)/doctor-signup-awaiting-approval')({
  component: AwaitingApproval,
})
